export default __webpack_public_path__ + "static/media/no.74d15443.jpg";